import React, { createContext } from 'react';

import { safeGet } from '../functions/safeStorage';
import { DEFAULT_PRIMARY_COLOR } from '../styles/defaults';

const LayoutContext = createContext({
  loginBanner: String,
  primeryColor: String,
  secondaryColor: String,
  footerBanner: String,
  logoDefault: String,
  logDark: String,
  logoDarkIcon: String,
  logLight: String,
  logoLoghtIcon: String,
  logoCircle: String,
});

export const LayoutProvider = ({ children }) => {
  // Consumidores fazem destructuring direto do value (ex.: AuthLayout com
  // `const { loginBanner } = useContext(LayoutContext)`), e desestruturar null
  // lança TypeError — por isso o value nunca pode ser null.
  //
  // `primaryColor` ganha um padrão porque as telas o aplicam em estilo inline
  // (ex.: `backgroundColor: primaryColor` no botão Entrar): sem valor o botão
  // fica branco sobre fundo branco, ilegível. Os demais campos podem seguir
  // undefined — cada tela já lida com a ausência.
  const layout = safeGet(localStorage, '@portal-cliente/layout');

  const value = {
    ...(layout || {}),
    primaryColor: (layout && layout.primaryColor) || DEFAULT_PRIMARY_COLOR,
  };

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};

export default LayoutContext;
